module.exports = {"532931101":"金华镇","532931102":"老君山镇","532931103":"甸南镇","532931104":"沙溪镇","532931105":"马登镇","532931201":"羊岑乡","532931202":"弥沙乡","532931203":"象图乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532931.json
// module id = 2658
// module chunks = 0